// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clock[data-v-f5caca24] {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  -webkit-transform: translate(-50%, -18px);\n          transform: translate(-50%, -18px);\n  width: 83px;\n  height: auto;\n  padding: 7px 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  border-radius: 8px;\n  z-index: 10;\n  text-align: center;\n}\n.clock .time[data-v-f5caca24] {\n  font-size: 16px;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
